// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"4200f919","93":"224e62fd","247":"dce7725f","263":"23728c2d","358":"3c0646a1","426":"027571a5","453":"76324dda","672":"c365a52b","739":"db49cd30"}[chunkId] + ".chunk.js";
};